// DatepickerFilterM.js

import {
    defineComponent,
    ref,
    computed,
    watch,
    onMounted,
    nextTick,
} from "/Scripts/vue.esm-browser.js";
const html = String.raw;

export default defineComponent({
    name: "DatepickerFilterM",

    props: {
        dateRangeStart: {
            type: String,
            default: "",
        },
        dateRangeEnd: {
            type: String,
            default: "",
        },
        dateRange: {
            type: Array,
            default: [],
        },
    },

    emits: ["update:updateDateRange"],

    setup(props, { emit }) {
        const rootEl = ref(null);
        // Handle quick date range selection
        const dateStart = ref(props.dateRangeStart);
        const dateEnd = ref(props.dateRangeEnd);

        // const setQuickDateRange = (days) => {
        //     const today = new Date();
        //     const endDate = new Date(today);
        //     endDate.setDate(today.getDate() + days);

        //     dateStart.value = today.toISOString().split("T")[0];
        //     dateEnd.value = endDate.toISOString().split("T")[0];
        //     emit("update:updateDateRange", dateStart.value, dateEnd.value);
        // };
        const setDateRange = (dateRange) => {
            dateStart.value = `${dateRange[0].getFullYear()}/${String(dateRange[0].getMonth() + 1).padStart(2, '0')}/${String(dateRange[0].getDate()).padStart(2, '0')}`;
            props.dateRange[0] = `${dateRange[0].getFullYear()}/${String(dateRange[0].getMonth() + 1).padStart(2, '0')}/${String(dateRange[0].getDate()).padStart(2, '0')}`;

            dateEnd.value = `${dateRange[1].getFullYear()}/${String(dateRange[1].getMonth() + 1).padStart(2, '0')}/${String(dateRange[1].getDate()).padStart(2, '0')}`;
            props.dateRange[1] = `${dateRange[1].getFullYear()}/${String(dateRange[1].getMonth() + 1).padStart(2, '0')}/${String(dateRange[1].getDate()).padStart(2, '0')}`;

            emit("update:updateDateRange", dateStart.value, dateEnd.value);
        };
        watch(
            () => props.dateRangeStart,
            (newVal) => {
                dateStart.value = newVal;
            }
        );
        watch(
            () => props.dateRangeEnd,
            (newVal) => {
                dateEnd.value = newVal;
            }
        );
        // Price range state
        return {
            // setQuickDateRange,
            setDateRange,
            dateStart,
            dateEnd,
            rootEl
        };
    },
    mounted() {
        this.$nextTick(() => {
            flatpickrService.init("m", this.setDateRange, this.rootEl);
        });

    },

    template: html`
        <div class="filterbox filterbox-date" ref="rootEl">
            <div class="filter_title">出發日期</div>
            <div class="filterSpace_input">
                <div class="input_bar">
                    <button class="input_bar_date-start">
                        {{ dateRange[0] }}
                    </button>
                    <span>~</span>
                    <button class="input_bar_date-end">
                        {{ dateRange[1] }}
                    </button>
                </div>
            </div>
            <div class="m_datepicker_wrap">
                <div class="button_group">
                    <button class="date_btn active">月曆</button>
                    <button class="selectRange_btn">快搜鍵</button>
                </div>
                <div class="date_wrap">
                    <div class="date_box">
                        <input
                            type="text"
                            id="m_datepicker"
                            placeholder="選擇日期"
                        />
                    </div>
                </div>
                <div class="selectDate_wrap">
                    <h3>想要什麼時候出發?</h3>
                    <div class="left_wrap">
                        <div class="radio" id="fourteen_m">
                            <input
                                class="radio_input"
                                type="radio"
                                id="fw-0m"
                                name="drone"
                            />
                            <label class="radio_label" for="fw-0m">
                                <div class="radio_textBox">
                                    <span>14天內</span>
                                </div>
                            </label>
                        </div>

                        <div class="radio" id="thirtyDays_m">
                            <input
                                class="radio_input"
                                type="radio"
                                id="fw-1m"
                                name="drone"
                            />
                            <label class="radio_label" for="fw-1m">
                                <div class="radio_textBox">
                                    <span>30天內</span>
                                </div>
                            </label>
                        </div>
                        <div class="radio" id="twoMonths_m">
                            <input
                                class="radio_input"
                                type="radio"
                                id="fw-2m"
                                name="drone"
                            />
                            <label class="radio_label" for="fw-2m">
                                <div class="radio_textBox">
                                    <span>兩個月內</span>
                                </div>
                            </label>
                        </div>

                        <div class="radio" id="threeMonths_m">
                            <input
                                class="radio_input"
                                type="radio"
                                id="fw-3m"
                                name="drone"
                            />
                            <label class="radio_label" for="fw-3m">
                                <div class="radio_textBox">
                                    <span>三個月內</span>
                                </div>
                            </label>
                        </div>

                        <div class="radio" id="fourMonths_m">
                            <input
                                class="radio_input"
                                type="radio"
                                id="fw-4m"
                                name="drone"
                            />
                            <label class="radio_label" for="fw-4m">
                                <div class="radio_textBox">
                                    <span>四個月內</span>
                                </div>
                            </label>
                        </div>

                        <div class="radio" id="sixMonths_m">
                            <input
                                class="radio_input"
                                type="radio"
                                id="fw-5m"
                                name="drone"
                            />
                            <label class="radio_label" for="fw-5m">
                                <div class="radio_textBox">
                                    <span>半年內</span>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="collapse_btn">
                    收合
                    <i class="fa-solid fa-chevron-up"></i>
                </div>
            </div>
        </div>
    `,
});
